import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ src, srcset, sizes, alt, ...rest }) => {
    if (!srcset) {
        // eslint-disable-next-line
        console.warn(
            'You are using the image element and not providing the srcset attribute'
        );
        return null;
    }

    return <img {...rest} src={src} srcSet={srcset} sizes={sizes} alt={alt} />;
};

Image.propTypes = {
    //srcset strings, path + width
    srcset: PropTypes.string,
    //sizes (media-queries) from srcset
    sizes: PropTypes.string,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
};

export default Image;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/image/image.jsx